import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { apiSlice } from './slices/apiSlice';
import appSlice from './slices/appSlice';
import authSlice from './slices/authSlice';
import toastSlice from './slices/toastSlice';
import calendarUISlice from './slices/calendarUISlice';
import { authMiddleware } from '../utils/authMiddleware';

export const store = configureStore({
  reducer: {
    app: appSlice,
    auth: authSlice,
    toast: toastSlice,
    calendarUI: calendarUISlice,
    api: apiSlice.reducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware()
      .concat(apiSlice.middleware)
      .concat(authMiddleware),
  devTools: import.meta.env.MODE !== 'production',
});

// Enable refetchOnFocus/refetchOnReconnect behaviors
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
